import APIService from '../../../Services/APIService';
import { Apis } from '../../../Services/app.constants';

export const userService = {
  async getUserList(data = {}) {
    let url = `${Apis.getUsersByOrganisation}?next_page=${data?.page || 1}&search=${data?.search || ''}&limit=${data?.limit || 20}`;
    if (data?.organisation_id) {
      url += `&organisation_id=${data.organisation_id}`;
    }
    if (data?.profile_id) {
      url += `&profile_id=${encodeURIComponent(data.profile_id)}`;
    }
    if (data?.is_active !== undefined && data?.is_active !== null && data?.is_active !== '') {
      url += `&is_active=${encodeURIComponent(data.is_active)}`;
    }
    return APIService.get(url);
  },

  async findProfileById(profileId, { organisationId = '' } = {}) {
    if (!profileId) {
      return null;
    }

    let page = 0;
    let totalPages = 1;

    while (page < totalPages) {
      const res = await this.getProfileList({
        page,
        limit: 50,
        organisation_id: organisationId || '',
      });

      if (res?.status !== 200) {
        return null;
      }

      const payload = res.data || {};
      totalPages = payload.pages || 1;
      const match = (payload.list || []).find(
        (item) => String(item.id) === String(profileId)
      );
      if (match) {
        return match;
      }
      page += 1;
    }

    return null;
  },

  async createUser(data) {
    return APIService.post(Apis.getUsersByOrganisation, data);
  },

  async updateUser(data) {
    return APIService.put(`${Apis.getUsersByOrganisation}${data?.id}/`, data);
  },

  async deleteUser(id) {
    return APIService.remove(`${Apis.getUsersByOrganisation}${id}/`);
  },

  async changeUserPassword(data) {
    return APIService.post(`${Apis.getUsersByOrganisation}${data.id}/change_password/`, data);
  },

  async unlockUser(username) {
    return APIService.get(`${Apis.unlockUser}?username=${username}`);
  },

  async setUserStatus(userId, isActive) {
    return APIService.post(`${Apis.getUsersByOrganisation}${userId}/set-status/`, {
      is_active: isActive,
    });
  },

  async getProfileList(data = {}) {
    let url = `${Apis.getProfileList}?next_page=${data?.page || 1}&search=${data?.search || ''}&limit=${data?.limit || 20}`;
    if (data?.organisation_id) {
      url += `&organisation_id=${data.organisation_id}`;
    } else if (data?.organisationId) {
      url += `&organisation_id=${data.organisationId}`;
    }
    return APIService.get(url);
  },
};
